// cleanup_convert_to_glu_component_GENERICS
// cleanup_convert_to_typescript_file_GENERICS

import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

import { Dropdown } from '@glu/dropdown-react';

import { DEFAULT_PROPS } from 'constants.js';

import ListPillCustomLink from './ListPillCustomLink';
import useStyles from './listPill.styles';

const { EMPTY_FUNCTION, EMPTY_OBJ } = DEFAULT_PROPS;

export const ListPillComponent = ({
  dataQa = 'list-pill',
  disabled = false,
  enableSearch = false,
  htmlId = 'dropdown',
  labelText = 'dropdown',
  links,
  onChange: onCustomChange = EMPTY_FUNCTION,
  optionLinkRole = undefined,
  state = EMPTY_OBJ
}) => {
  const { reactDropdown } = useStyles();
  const history = useHistory();
  const [dropdownPlaceholder, ...rest] = links;
  const list = rest.map((obj) => ({ ...obj, id: obj.name, dataQa: obj?.dataQa }));

  const handleChange = (_name, option) => {
    const [{ path, state, value } = {}] = option;

    // This ensures the option works with keyboard for if option is selected rather than just link
    if (path) {
      history.push({
        pathname: path,
        state
      });
    }

    onCustomChange(value);
  };

  return (
    <div className="list-pill" data-qa={dataQa}>
      <Dropdown
        className={reactDropdown}
        disabled={disabled}
        filterEnabled={enableSearch}
        // format as empty string to keep placeholder showing
        format={() => ''}
        htmlId={htmlId}
        labelText={labelText}
        name="dropdown"
        onChange={handleChange}
        optionComponent={(params) => (
          <ListPillCustomLink
            linkRole={optionLinkRole}
            onChange={onCustomChange}
            params={params}
            state={state}
          />
        )}
        options={list}
        placeholder={dropdownPlaceholder.name}
        screenReaderLabel
        // Set an empty value because we don't want to show the value of the dropdown in the view
        value={[{ id: '', name: '' }]}
      />
    </div>
  );
};

ListPillComponent.propTypes = {
  dataQa: PropTypes.string,
  disabled: PropTypes.bool,
  enableSearch: PropTypes.bool,
  htmlId: PropTypes.string,
  labelText: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string
    })
  ).isRequired,
  onChange: PropTypes.func,
  state: PropTypes.shape({}),
  optionLinkRole: PropTypes.string
};

export default ListPillComponent;
